
import './App.css';
import Education from './Component/Education/Education';
import Experience from './Component/Experience/Experience';
import Footer from './Component/Footer/Footer';
import Header from './Component/Header/Header';
import Hero from './Component/Hero/Hero';
import Publications from './Component/Publications/Publications';
import Skills from './Component/Skills/Skills';
function App() {
  return (
    <>
    <Header/>
    <Hero/>
    <Education/>
    <Experience/>
    <Publications/>
    <Skills/>
    <Footer/>
    </>
  );
}

export default App;
